/**
 * The name-your-cat card's skeleton.  packages/client/src/join.js drives it (the DENY
 * sentences live there); the "Build your cat" button reaches the customizer
 * through the #open-customizer handle boot passes in, never an id lookup.
 */
import "./join.css";
import { mount } from "./dom.js";

export function mountJoin() {
  return mount(`
<!-- The name-your-cat card, shown only to new players (a returning token
     skips it entirely).  Driven by join.js; the DENY sentences live there. -->
<div id="join" class="panel hidden" role="dialog" aria-label="Name your cat">
  <div class="label">A new cat moves in</div>
  <div id="join-lead">Sixteen cats can live on this street.
    Name yours and it&rsquo;s yours to keep.</div>
  <div id="join-deny" hidden></div>
  <input id="join-name" type="text" autocomplete="off" spellcheck="false"
         placeholder="Your cat&rsquo;s name" aria-label="Your cat's name">
  <div class="switch">
    <button id="join-play" type="button">Play</button>
    <button id="join-build" type="button">Build your cat &middot; B</button>
  </div>
</div>`);
}
